import { useRef } from "react"
import Link from "next/link"
import { useRouter } from "next/router"
import useOnClickOutside from "@/lib/hooks/useOnClickOutside"
import useMenuItems from "@/lib/helpers/menu"
import Social from "@/common/social/social"
import Menu from "@/components/common/menu/menu"
import Close from "@/components/common/icons/close"
import Burger from "@/components/common/icons/menu"
import { useCopy, useMeta, useAdminBar } from "@/lib/contexts/appContext"
import classNames from "classnames/bind"
import styles from "./primary.module.css"
import { submenu } from "./menu.module.css"

export default function Primary({ isActive, setActive, isNarrow, hasMounted }) {
  const offCanvasRef = useRef(null)
  const cx = classNames.bind(styles)
  const { general } = useCopy()
  const { hideSwitcher } = useMeta()
  const adminBar = useAdminBar()
  const { locale } = useRouter()
  const oppositeLocale = locale === "sv" ? "en" : "sv"

  useOnClickOutside(offCanvasRef, () => setActive("offCanvas", false), isActive)

  const items = [].concat(
    useMenuItems("primary-bramiljoval") ?? [],
    useMenuItems("top-bramiljoval") ?? []
  )

  if (items.length === 0) {
    return null
  }

  if (hasMounted && !isNarrow) {
    return null
  }

  return (
    <div className={classNames(styles.primary)} ref={offCanvasRef}>
      <button
        id="menubutton"
        type="button"
        aria-label={isActive ? "Stäng meny" : "Öppna meny"}
        aria-haspopup="true"
        aria-controls="primary-menu"
        className="toggle"
        onClick={() => setActive("offCanvas", !isActive)}>
        {isActive ? <Close className="close" /> : <Burger className="burger" />}
      </button>
      {items.length > 0 && (
        <div
          className={cx(
            { submenu: true, on: isActive, "has-admin-bar": adminBar },
            submenu
          )}>
          {isActive && (
            <nav id="primary-menu">
              <Menu
                menuClasses="primary"
                items={items}
                location="primary"
                ariaLabelledby="menubutton"
              />
              {!hideSwitcher && (
                <Link
                  className="lang-switcher"
                  href="/"
                  locale={oppositeLocale}
                  prefetch={false}>
                  {general?.langSwitcher}
                </Link>
              )}
              <Social styles={styles} location="primary" />
            </nav>
          )}
        </div>
      )}
    </div>
  )
}
